var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path61, _path62, _path63;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotaAtribuida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 228,
    viewBox: "0 0 309 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8062 211.292L88.8037 211.292C84.5231 211.297 81.0001 207.777 81.0001 203.486L81.0001 68.806C81.0001 64.5156 84.5158 61 88.8062 61L187.355 61C191.645 61 195.161 64.5157 195.161 68.806L195.161 203.486C195.161 207.776 191.645 211.292 187.355 211.292L88.8062 211.292Z",
    stroke: "#47D19D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5665 36.3794H54.9561V47.9898H66.5665V36.3794Z",
    fill: "#47D19D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2753 38.5205H78.6768V41.119H81.2753V38.5205Z",
    fill: "#4D5884"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6366 41.119H72.5963V38.5205H75.6366V41.119ZM69.5495 41.119H66.5093V38.5205H69.5495V41.119Z",
    fill: "#4D5884"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4689 38.5205H60.8704V41.119H63.4689V38.5205Z",
    fill: "#4D5884"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4689 35.4802H60.8704V32.4399H63.4689V35.4802ZM63.4689 29.3996H60.8704V26.3594H63.4689V29.3996Z",
    fill: "#4D5884"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4691 20.7139H60.8706V23.3124H63.4691V20.7139Z",
    fill: "#4D5884"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6366 23.3124H72.5963V20.7139H75.6366V23.3124ZM69.5495 23.3124H66.5093V20.7139H69.5495V23.3124Z",
    fill: "#4D5884"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2753 20.7139H78.6768V23.3124H81.2753V20.7139Z",
    fill: "#4D5884"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2753 35.4802H78.6768V32.4399H81.2753V35.4802ZM81.2753 29.3996H78.6768V26.3594H81.2753V29.3996Z",
    fill: "#4D5884"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.481 132.82H209.762V135.418H221.481V132.82Z",
    fill: "#4D5884"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M227.615 132.82H223.71V135.418H227.615V132.82Z",
    fill: "#4D5884"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M238.274 126.941H220.325V129.539H238.274V126.941Z",
    fill: "#4D5884"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M298.451 184.065L300.601 188.411L305.395 189.113L301.926 192.498L302.745 197.279L298.451 195.018L294.157 197.279L294.982 192.498L291.506 189.113L296.307 188.411L298.451 184.065Z",
    fill: "#E3E4ED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M292.435 199.65L293.585 192.946L288.712 188.197L295.443 187.216L298.45 181.123L301.458 187.216L308.188 188.197L303.316 192.946L304.466 199.65L298.45 196.486L292.435 199.65ZM298.45 193.55L301.016 194.901L300.529 192.043L302.608 190.016L299.737 189.6L298.45 187.002L297.164 189.6L294.293 190.016L296.372 192.043L295.884 194.901L298.45 193.55Z",
    fill: "#E3E4ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5967 175.154H44.4023V177.752H58.5967V175.154Z",
    fill: "#4D5884"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0013 169.925H49.8069V172.523H64.0013V169.925Z",
    fill: "#4D5884"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.105 169.925H42.3757V172.523H47.105V169.925Z",
    fill: "#4D5884"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6998 175.154H36.9705V177.752H41.6998V175.154Z",
    fill: "#4D5884"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M265.444 43.6475H252.549V46.246H265.444V43.6475Z",
    fill: "#4D5884"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M248.548 43.6479H243.819V46.2465H248.548V43.6479Z",
    fill: "#4D5884"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M265.445 35.605H252.55V38.2035H265.445V35.605Z",
    fill: "#4D5884"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.549 35.605H243.819V38.2035H248.549V35.605Z",
    fill: "#4D5884"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M200.637 43.5109C198.077 43.5109 195.998 41.4321 195.998 38.8726C195.998 36.313 198.077 34.2407 200.637 34.2407C203.19 34.2407 205.268 36.3195 205.268 38.8726C205.268 41.4256 203.19 43.5109 200.637 43.5109ZM200.637 36.8327C199.513 36.8327 198.597 37.7487 198.597 38.8661C198.597 39.9899 199.513 40.9059 200.637 40.9059C201.76 40.9059 202.67 39.9899 202.67 38.8661C202.67 37.7487 201.76 36.8327 200.637 36.8327Z",
    fill: "#4D5884"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M219.106 33.5982C216.553 33.5982 214.474 31.5194 214.474 28.9663C214.474 26.4133 216.553 24.3345 219.106 24.3345C221.659 24.3345 223.745 26.4133 223.745 28.9663C223.745 31.5194 221.659 33.5982 219.106 33.5982ZM219.106 26.9265C217.982 26.9265 217.073 27.8425 217.073 28.9598C217.073 30.0772 217.989 30.9932 219.106 30.9932C220.23 30.9932 221.146 30.0772 221.146 28.9598C221.146 27.8425 220.23 26.9265 219.106 26.9265Z",
    fill: "#4D5884"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M219.106 53.4182C216.553 53.4182 214.474 51.3393 214.474 48.7798C214.474 46.2268 216.553 44.1479 219.106 44.1479C221.659 44.1479 223.745 46.2268 223.745 48.7798C223.738 51.3393 221.659 53.4182 219.106 53.4182ZM219.106 46.7465C217.982 46.7465 217.073 47.6624 217.073 48.7798C217.073 49.9037 217.989 50.8196 219.106 50.8196C220.23 50.8196 221.146 49.9037 221.146 48.7798C221.14 47.6624 220.23 46.7465 219.106 46.7465Z",
    fill: "#4D5884"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.491 39.0549L203.192 41.3052L215.034 48.1439L216.334 45.8936L204.491 39.0549Z",
    fill: "#4D5884"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M215.028 29.6064L203.185 36.4424L204.484 38.693L216.327 31.857L215.028 29.6064Z",
    fill: "#4D5884"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5581 36.5242H28.0601C27.7099 36.5242 27.3403 36.2583 27.2301 35.9276L26.9512 35.2532C26.7956 34.9419 26.8734 34.488 27.1133 34.2415L28.1704 33.1845C28.4168 32.9381 28.4168 32.536 28.1704 32.2961L26.5362 30.6554C26.2898 30.409 25.8877 30.409 25.6413 30.6554L24.5842 31.7125C24.3378 31.9589 23.8839 32.0302 23.5726 31.8811L22.8982 31.6022C22.5675 31.492 22.3016 31.1159 22.3016 30.7722V29.2742C22.3016 28.924 22.0163 28.6387 21.6726 28.6387H19.3575C19.0073 28.6387 18.722 28.924 18.722 29.2742V30.7722C18.722 31.1224 18.4561 31.492 18.1254 31.6022L17.4509 31.8811C17.1397 32.0367 16.6857 31.9589 16.4393 31.7125L15.3823 30.6554C15.1359 30.409 14.7338 30.409 14.4874 30.6554L12.8532 32.2961C12.6068 32.5425 12.6068 32.9446 12.8532 33.1845L13.9102 34.2415C14.1502 34.488 14.228 34.9419 14.0724 35.2532L13.7935 35.9276C13.6833 36.2583 13.3072 36.5242 12.9635 36.5242H11.4655C11.1218 36.5242 10.8364 36.8096 10.8364 37.1532V39.4683C10.8364 39.812 11.1218 40.0973 11.4655 40.0973H12.9635C13.3072 40.0973 13.6833 40.3632 13.7935 40.694L14.0724 41.3684C14.228 41.6797 14.1502 42.1336 13.9102 42.38L12.8532 43.437C12.6068 43.6835 12.6068 44.0855 12.8532 44.3319L14.4874 45.9726C14.7338 46.219 15.1359 46.219 15.3823 45.9726L16.4393 44.9156C16.6857 44.6692 17.1397 44.5978 17.4509 44.7535L18.1254 45.0323C18.4561 45.1425 18.722 45.5187 18.722 45.8624V47.3603C18.722 47.7105 19.0073 47.9894 19.3575 47.9894H21.6726C22.0227 47.9894 22.3016 47.704 22.3016 47.3603V45.8624C22.3016 45.5122 22.5675 45.1425 22.8982 45.0323L23.5726 44.7535C23.8839 44.5978 24.3378 44.6756 24.5842 44.9156L25.6413 45.9726C25.8877 46.219 26.2898 46.219 26.5362 45.9726L28.1704 44.3319C28.4168 44.0855 28.4168 43.6835 28.1704 43.437L27.1133 42.38C26.8669 42.1336 26.7956 41.6797 26.9512 41.3684L27.2301 40.694C27.3403 40.3632 27.7099 40.0973 28.0601 40.0973H29.5581C29.9083 40.0973 30.1871 39.812 30.1871 39.4683V37.1532C30.1871 36.8096 29.9018 36.5242 29.5581 36.5242ZM20.5053 41.3619C18.8192 41.3619 17.4574 39.9936 17.4574 38.3075C17.4574 36.6215 18.8257 35.2597 20.5053 35.2597C22.1913 35.2597 23.5596 36.628 23.5596 38.3075C23.5596 39.9936 22.1913 41.3619 20.5053 41.3619Z",
    fill: "#47D19D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M280.126 72.8614C279.028 72.8614 278.236 71.9974 278.236 70.8021V60.7328C278.236 59.5375 279.035 58.667 280.126 58.667C280.503 58.667 280.886 58.7774 281.25 58.9853L289.968 64.0199C290.663 64.4162 291.06 65.0528 291.06 65.7609C291.06 66.469 290.663 67.1057 289.968 67.5084L281.25 72.5431C280.886 72.7509 280.51 72.8614 280.126 72.8614ZM280.834 61.7462V69.7886L287.792 65.7674L280.834 61.7462Z",
    fill: "#4D5884"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.942 32.6772H146.193V35.2758H149.942V32.6772Z",
    fill: "#4D5884"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M144.648 26.5465L142.774 29.793L145.025 31.092L146.899 27.8455L144.648 26.5465Z",
    fill: "#4D5884"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M138.94 26.7818L136.69 28.0806L138.563 31.327L140.814 30.0283L138.94 26.7818Z",
    fill: "#4D5884"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M137.793 33.1191H134.044V35.7177H137.793V33.1191Z",
    fill: "#4D5884"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.961 37.2877L137.087 40.5342L139.337 41.8332L141.211 38.5867L138.961 37.2877Z",
    fill: "#4D5884"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M145.406 37.0784L143.156 38.3774L145.029 41.6239L147.28 40.3249L145.406 37.0784Z",
    fill: "#4D5884"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M294.247 91.335H291.649V95.4406H294.247V91.335Z",
    fill: "#4D5884"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M286.918 94.0991L285.619 96.3491L289.174 98.4028L290.473 96.1527L286.918 94.0991Z",
    fill: "#4D5884"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M289.172 99.7586L285.616 101.811L286.915 104.062L290.471 102.009L289.172 99.7586Z",
    fill: "#4D5884"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M294.247 102.684H291.649V106.79H294.247V102.684Z",
    fill: "#4D5884"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M296.738 99.7707L295.439 102.021L298.995 104.074L300.294 101.824L296.738 99.7707Z",
    fill: "#4D5884"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M298.997 94.0887L295.441 96.1411L296.74 98.3917L300.296 96.3393L298.997 94.0887Z",
    fill: "#4D5884"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M303.143 132.191C301.766 132.21 300.577 132.977 299.927 134.12C299.245 132.996 298.037 132.256 296.66 132.269C294.568 132.275 292.898 134.133 292.924 136.42C292.931 136.862 293.002 137.284 293.126 137.674C293.418 138.96 295.542 140.844 297.498 142.37C298.446 143.105 300.051 144.202 300.051 144.209C300.726 143.78 301.623 143.085 302.552 142.325C304.468 140.753 306.534 138.811 306.794 137.511C306.911 137.121 306.969 136.693 306.963 136.251C306.95 133.951 305.228 132.145 303.143 132.191Z",
    fill: "#E3E4ED"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M298.758 146.568V144.885C298.193 144.489 297.328 143.878 296.705 143.397C292.898 140.435 292.105 138.967 291.872 138.019C291.716 137.512 291.631 136.973 291.625 136.433C291.605 134.939 292.177 133.484 293.19 132.451C294.126 131.503 295.354 130.97 296.653 130.97C297.874 130.97 299.005 131.386 299.901 132.126C300.791 131.36 301.928 130.905 303.123 130.892H303.214C305.969 130.892 308.242 133.289 308.275 136.232C308.281 136.778 308.21 137.31 308.067 137.824C307.872 138.714 307.138 140.253 303.383 143.326C302.298 144.222 301.415 144.885 300.752 145.307L298.758 146.568ZM296.705 133.569C296.068 133.569 295.49 133.822 295.048 134.277C294.516 134.816 294.223 135.595 294.23 136.407C294.23 136.713 294.282 137.005 294.366 137.278L294.399 137.388C294.444 137.577 294.827 138.642 298.303 141.345C298.816 141.741 299.531 142.248 300.07 142.624C300.544 142.28 301.109 141.838 301.739 141.312C305.131 138.532 305.494 137.434 305.533 137.245L305.559 137.135C305.637 136.862 305.683 136.563 305.676 136.258C305.657 134.731 304.552 133.484 303.214 133.484C302.285 133.497 301.499 133.971 301.051 134.757L299.953 136.68L298.81 134.783C298.348 134.023 297.562 133.569 296.705 133.569Z",
    fill: "#E3E4ED"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6787 115.642H40.0889V118.24H52.6787V115.642Z",
    fill: "#4D5884"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6907 115.642H33.4941V118.241H37.6907V115.642Z",
    fill: "#4D5884"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29926 108.489H0V111.087H1.29926V108.489Z",
    fill: "#4D5884"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4706 111.087H33.9565V108.489H36.4706V111.087ZM31.4424 111.087H28.9284V108.489H31.4424V111.087ZM26.4208 111.087H23.9067V108.489H26.4208V111.087ZM21.3992 111.087H18.8851V108.489H21.3992V111.087ZM16.371 111.087H13.857V108.489H16.371V111.087ZM11.3494 111.087H8.83535V108.489H11.3494V111.087ZM6.32779 111.087H3.81372V108.489H6.32779V111.087Z",
    fill: "#4D5884"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2775 108.489H38.9783V111.087H40.2775V108.489Z",
    fill: "#4D5884"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M181.432 37.1557L175.704 42.8838L177.542 44.7212L183.27 38.9931L181.432 37.1557Z",
    fill: "#4D5884"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M177.544 37.1533L175.706 38.9907L181.434 44.7188L183.272 42.8814L177.544 37.1533Z",
    fill: "#4D5884"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6908 63.4701L30.9626 69.1982L32.8001 71.0357L38.5282 65.3075L36.6908 63.4701Z",
    fill: "#4D5884"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7991 63.4717L30.9617 65.3091L36.6898 71.0372L38.5272 69.1998L32.7991 63.4717Z",
    fill: "#4D5884"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.096 13.9634L102.002 19.0576L103.839 20.895L108.934 15.8008L107.096 13.9634Z",
    fill: "#4D5884"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M103.855 13.9529L102.018 15.7905L107.113 20.8848L108.95 19.0471L103.855 13.9529Z",
    fill: "#4D5884"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M176.64 13.2583H174.002V15.8568H176.64V13.2583Z",
    fill: "#4D5884"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9622 88.5776H30.3247V91.1762H32.9622V88.5776Z",
    fill: "#4D5884"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M207.033 -8.37047e-05L200.212 6.82129L202.049 8.6587L208.871 1.83733L207.033 -8.37047e-05Z",
    fill: "#4D5884"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M202.055 0.000481176L200.217 1.83789L207.039 8.65927L208.876 6.82187L202.055 0.000481176Z",
    fill: "#4D5884"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M302.819 225.312H4.64429V228H302.819V225.312Z",
    fill: "#4D5884"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 91.8296,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 106.14,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 120.45,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 134.76,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 149.071,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 163.381,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 99.0598,
    y: 177.691,
    width: 76.6022,
    height: 3.36713,
    fill: "#E3E4ED"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M202 208C225.196 208 244 189.196 244 166C244 142.804 225.196 124 202 124C178.804 124 160 142.804 160 166C160 189.196 178.804 208 202 208Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M202 202.352C181.954 202.352 165.648 186.047 165.648 166C165.648 145.954 181.954 129.648 202 129.648C222.047 129.648 238.352 145.954 238.352 166C238.352 186.047 222.04 202.352 202 202.352ZM202 134.299C184.518 134.299 170.299 148.518 170.299 166C170.299 183.482 184.518 197.701 202 197.701C219.482 197.701 233.701 183.482 233.701 166C233.701 148.518 219.475 134.299 202 134.299Z",
    fill: "#4D5884"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M197.15 180.824L183.07 166.751L188.711 161.116L197.15 169.548L215.289 151.409L220.924 157.05L197.15 180.824Z",
    fill: "#4D5884"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotaAtribuida);
export default __webpack_public_path__ + "static/media/nota_atribuida.d8648c1bdd43b1a886713491dca2acc1.svg";
export { ForwardRef as ReactComponent };